"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterPropsFromPropTypes = exports.filterProps = exports.filterObjectProps = exports.excludeContextProps = void 0;
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
var _context = require("../context");
/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which only allows props which aren't present in `propsToFilter`.
 *
 * @param {Array<string>} propsToFilter Array of blacklisted prop names
 */
const filterProps = function () {
  let propsToFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return prop => propsToFilter.includes(prop) === false;
};

/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which only allows props which aren't present in `propTypes`.
 *
 * @param {Object<string,*>} propTypes Object where the keys are blacklisted prop names
 * @param {{additionalPropsToFilter: Array<String>, propsToForward: Array<String>}} options
 *    Additional prop names to include or exclude from the filter
 */
exports.filterProps = filterProps;
const filterPropsFromPropTypes = function () {
  let propTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    additionalPropsToFilter = [],
    propsToForward = [],
    filterInvalidHTML = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const propsToFilter = Object.keys(propTypes).filter(prop => propsToForward.includes(prop) === false);
  const filterFn = filterProps([...propsToFilter, ...additionalPropsToFilter]);
  if (!filterInvalidHTML) {
    return filterFn;
  }
  return prop => (0, _isPropValid.default)(prop) && filterFn(prop);
};

/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which composes the given `shouldForwardProp` function with a filter to
 * filter out Stencil context props.
 */
exports.filterPropsFromPropTypes = filterPropsFromPropTypes;
const excludeContextProps = filterFn => prop => filterFn(prop) && !_context.STENCIL_CONTEXT_PROPS.includes(prop);

/**
 * Filters properties from an object based on keys to be removed.
 * Note: This function only performs a shallow copy of the object and should be
 * used primarily for filtering simple non-nested objects like PropType definitions.
 *
 * @param obj The source object
 * @param propsToFilter Array of property names to filter out
 * @returns A new object with only the properties that weren't filtered
 */
exports.excludeContextProps = excludeContextProps;
const filterObjectProps = (obj, propsToFilter) => {
  const result = {
    ...obj
  };
  propsToFilter.forEach(prop => {
    delete result[prop];
  });
  return result;
};
exports.filterObjectProps = filterObjectProps;